import Cookies from "js-cookie";

import { envChecker } from "helpers/envChecker";

import { MAIN_DOMAIN } from "config";
import { EENV } from "constants/index";

export const deleteCookies = (key: string) => {
  const { hostname } = new URL(MAIN_DOMAIN);
  Cookies.remove(key, {
    domain: envChecker({ envs: [EENV.DEV] }) ? undefined : `.${hostname}`,
  });
};
